import { useListContext, useTranslate } from "ra-core";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

/**
 * Active / All switch for the classes list. It lives in the toolbar rather
 * than among the filters, so it can't be removed by accident.
 */
export const ActiveClassesToggle = () => {
  const translate = useTranslate();
  const { filterValues, displayedFilters, setFilters } = useListContext();
  const value = filterValues.active === true ? "active" : "all";

  const handleChange = (next: string) => {
    if (!next || next === value) return;
    const { active: _active, ...rest } = filterValues;
    setFilters(next === "active" ? { ...rest, active: true } : rest, {
      ...displayedFilters,
    });
  };

  return (
    <ToggleGroup
      type="single"
      variant="outline"
      value={value}
      onValueChange={handleChange}
      aria-label={translate("resources.classes.filters.show")}
    >
      <ToggleGroupItem value="active">
        {translate("resources.classes.filters.active")}
      </ToggleGroupItem>
      <ToggleGroupItem value="all">
        {translate("resources.classes.filters.all")}
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
